import gql from 'graphql-tag'

const GC_GET_PRODUCT_LIST = gql`
query GetProductList {
	gescof_product {
		id
		name
	}
  }
`

export {
	GC_GET_PRODUCT_LIST,
}